import React from 'react';

const GCCartContext = React.createContext();

export const GCCartProvider = GCCartContext.Provider;
export const GCCartConsumer = GCCartContext.Consumer;
export default GCCartContext;